// extracted by mini-css-extract-plugin
export default {"MarketPlace":"marketplace_MarketPlace__PcXLO","Market":"marketplace_Market__eWkax"};